import React, { useState } from 'react';
import { X, FileText, FileSpreadsheet, Download } from 'lucide-react';

const ExportTypeModal = ({ isOpen, onClose, onConfirm, companyName = 'Trip Sheet' }) => {
  const [selectedType, setSelectedType] = useState('Summary');
  const [fileFormat, setFileFormat] = useState('xlsx');

  if (!isOpen) return null;

  const handleDownload = () => {
    onConfirm(selectedType, fileFormat);
    onClose();
  };

  return (
    <div style={{
      position: 'fixed',
      inset: 0,
      backgroundColor: 'rgba(0,0,0,0.5)',
      zIndex: 9999,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }}>
      <div style={{
        width: '90%',
        maxWidth: '480px',
        backgroundColor: 'white',
        borderRadius: '12px',
        boxShadow: '0 24px 48px rgba(0,0,0,0.2)',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column'
      }}>
        {/* Modal Header */}
        <div style={{
          padding: '16px 20px',
          backgroundColor: '#20B967',
          color: 'white',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <h3 style={{ margin: 0, fontSize: '16px', fontWeight: 600 }}>Download Report</h3>
          <button onClick={onClose} style={{ background: 'none', border: 'none', color: 'white', cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
            <X size={20} />
          </button>
        </div>

        {/* Modal Body */}
        <div style={{ padding: '20px', display: 'flex', flexDirection: 'column', gap: '16px' }}>
          <div>
            <label style={{ display: 'block', fontSize: '13px', fontWeight: 600, color: '#374151', marginBottom: '8px' }}>
              Select Report Type
            </label>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
              {/* Option: Summary */}
              <div
                onClick={() => setSelectedType('Summary')}
                style={{
                  padding: '12px 14px',
                  borderRadius: '8px',
                  border: selectedType === 'Summary' ? '2px solid #20B967' : '1px solid #E5E7EB',
                  backgroundColor: selectedType === 'Summary' ? '#F0FDF4' : 'white',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '12px',
                  transition: 'all 0.15s'
                }}
              >
                <div style={{
                  width: '38px',
                  height: '38px',
                  borderRadius: '8px',
                  backgroundColor: selectedType === 'Summary' ? '#DCFCE7' : '#F3F4F6',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: selectedType === 'Summary' ? '#15803D' : '#6B7280'
                }}>
                  <FileSpreadsheet size={20} />
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: '14px', fontWeight: 600, color: '#1F2937' }}>Summary Report</div>
                  <div style={{ fontSize: '12px', color: '#6B7280' }}>Vehicle-wise financial payout summary report</div>
                </div>
                <input
                  type="radio"
                  name="exportType"
                  checked={selectedType === 'Summary'}
                  onChange={() => setSelectedType('Summary')}
                  style={{ accentColor: '#20B967', width: '16px', height: '16px' }}
                />
              </div>

              {/* Option: MIS */}
              <div
                onClick={() => setSelectedType('MIS')}
                style={{
                  padding: '12px 14px',
                  borderRadius: '8px',
                  border: selectedType === 'MIS' ? '2px solid #20B967' : '1px solid #E5E7EB',
                  backgroundColor: selectedType === 'MIS' ? '#F0FDF4' : 'white',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '12px',
                  transition: 'all 0.15s'
                }}
              >
                <div style={{
                  width: '38px',
                  height: '38px',
                  borderRadius: '8px',
                  backgroundColor: selectedType === 'MIS' ? '#DCFCE7' : '#F3F4F6',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: selectedType === 'MIS' ? '#15803D' : '#6B7280'
                }}>
                  <FileText size={20} />
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: '14px', fontWeight: 600, color: '#1F2937' }}>MIS Report</div>
                  <div style={{ fontSize: '12px', color: '#6B7280' }}>Detailed line-by-line trip sheet report</div>
                </div>
                <input
                  type="radio"
                  name="exportType"
                  checked={selectedType === 'MIS'}
                  onChange={() => setSelectedType('MIS')}
                  style={{ accentColor: '#20B967', width: '16px', height: '16px' }}
                />
              </div>
            </div>
          </div>

          {/* Format Selector */}
          <div>
            <label style={{ display: 'block', fontSize: '13px', fontWeight: 600, color: '#374151', marginBottom: '8px' }}>
              File Format
            </label>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
              <div
                onClick={() => setFileFormat('xlsx')}
                style={{
                  padding: '10px 14px',
                  borderRadius: '8px',
                  border: fileFormat === 'xlsx' ? '2px solid #20B967' : '1px solid #E5E7EB',
                  backgroundColor: fileFormat === 'xlsx' ? '#F0FDF4' : 'white',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  transition: 'all 0.15s'
                }}
              >
                <div>
                  <div style={{ fontSize: '13px', fontWeight: 600, color: '#1F2937' }}>Excel (.xlsx)</div>
                  <div style={{ fontSize: '11px', color: '#6B7280' }}>Spreadsheet format</div>
                </div>
                <input
                  type="radio"
                  name="fileFormat"
                  checked={fileFormat === 'xlsx'}
                  onChange={() => setFileFormat('xlsx')}
                  style={{ accentColor: '#20B967', width: '16px', height: '16px' }}
                />
              </div>

              <div
                onClick={() => setFileFormat('csv')}
                style={{
                  padding: '10px 14px',
                  borderRadius: '8px',
                  border: fileFormat === 'csv' ? '2px solid #20B967' : '1px solid #E5E7EB',
                  backgroundColor: fileFormat === 'csv' ? '#F0FDF4' : 'white',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  transition: 'all 0.15s'
                }}
              >
                <div>
                  <div style={{ fontSize: '13px', fontWeight: 600, color: '#1F2937' }}>CSV (.csv)</div>
                  <div style={{ fontSize: '11px', color: '#6B7280' }}>Comma-separated text</div>
                </div>
                <input
                  type="radio"
                  name="fileFormat"
                  checked={fileFormat === 'csv'}
                  onChange={() => setFileFormat('csv')}
                  style={{ accentColor: '#20B967', width: '16px', height: '16px' }}
                />
              </div>
            </div>
          </div>
        </div>

        {/* Modal Actions */}
        <div style={{
          padding: '14px 20px',
          backgroundColor: '#F9FAFB',
          borderTop: '1px solid #E5E7EB',
          display: 'flex',
          justifyContent: 'flex-end',
          gap: '10px'
        }}>
          <button
            onClick={onClose}
            style={{
              padding: '8px 16px',
              border: '1px solid #D1D5DB',
              borderRadius: '6px',
              backgroundColor: 'white',
              cursor: 'pointer',
              fontSize: '13px',
              fontWeight: 500,
              color: '#374151'
            }}
          >
            Cancel
          </button>
          <button
            onClick={handleDownload}
            style={{
              padding: '8px 18px',
              backgroundColor: '#20B967',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer',
              fontSize: '13px',
              fontWeight: 600,
              display: 'flex',
              alignItems: 'center',
              gap: '6px'
            }}
          >
            <Download size={16} /> Download {selectedType} ({fileFormat.toUpperCase()})
          </button>
        </div>
      </div>
    </div>
  );
};

export default ExportTypeModal;
